import { request } from "../network/request";
const db = "dn0";
//查询汇报预约列表
export function getKhhbyyList(params) {
  return request({
    url: "pmp/kh/khhbyyList",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}

// 导出汇报预约列表
export function khhbyyExport(params) {
  return request({
    url: "pmp/kh/khhbyyExport",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}


// 删除汇报预约
export function deleteHbyyById(id) {
  return request({
    url: 'pmp/kh/deleteHbyyById',
    method: 'get',
    params: { id: id },
  })
}
// 确认汇报预约
export function updatehbyy(id) {
  return request({
    url: 'pmp/kh/updatehbyy',
    method: 'get',
    params: { id: id },
  })
}

//新增/编辑汇报预约
export function saveHbyy(params) {
  return request({
    url: "pmp/kh/saveHbyy",
    method: "post",
    data: params,
  });
}

// 获取汇报预约
export function getHbyyById(id) {
  return request({
    url: 'pmp/kh/getHbyyById',
    method: 'get',
    params: { id: id },
  })
}

/**
 * 汇报预约获取项目信息-新增
 * @param {*} params
 * @returns
 */
export function getHbyyXmxx(params) {
  return request({
      url: "pmp/kh/getHbyyXmxx",
      method: "get",
      params,
  });
}


/**
 * 获取项目总监列表
 * @returns
 */
export function getKhyyr(bmbh) {
  return request({
    url: "pmp/cbhs/getKhyyr",
    method: "get",
    params: { bmbh },
  });
}

export function getKeyValue(stringType,bmbh, status) {
  return request({
    url: 'pmp/taskType/getKeyValue',
    method: 'get',
    params: { db, stringType,bmbh, status },
  })
}


export function getBmxxList( status) {
  return request({
    url: "pmp/taskType/getBmxxList",
    method: "get",
    params: {
      db,
      status,
    },
  });
}

export function getTasklxList(bmbh,txlx) {
  return request({
    url: "pmp/taskType/getTasklxList",
    method: "get",
    params: {
      db,
      bmbh,
      txlx,
    },
  });
}
export function getTaskZlList(name, bmbh, txlx) {
  return request({
    url: "pmp/taskType/getTaskZlList",
    method: "get",
    params: {
      db,
      name,
      bmbh,
      txlx,
    },
  });
}
/**
 * 新增任务类型
 * @param {*} params 
 * @returns 
 */
export function saveAddTaskType(params) {
  return request({
    url: "pmp/taskType/saveTaskType",
    method: "post",
    data: params,
  });
}

export function saveEditTaskType(params) {
  return request({
    url: "pmp/taskType/updateTaskType",
    method: "post",
    data: params,
  });
}


/**
 * 任务类型回显
 * @param {*} params 
 * @returns 
 */
export function getTaskType(params) {
  return request({
    url: "pmp/taskType/getTaskType",
    method: "get",
    params,
  });
}

export function getXmxx(bmbh, areaDirector) {
  return request({
    url: "pmp/cbhs/getXmxx",
    method: "get",
    params: { bmbh, areaDirector, htlx: 'DS' },
  });
}
//查询绩效管家绑定列表
export function getBindList(params) {
  return request({
    url: "pmp/kh/bindList",
    method: "post",
    params: {
      db,
      ...params,
    },
  });
}

// 绩效管家绑定列表导出
export function exportBindList(params) {
  return request({
    url: "pmp/kh/exportBindList",
    method: "post",
    params: {
      db,
      ...params,
    },
  });
}